import PropTypes from 'prop-types'
import { ArrowLeft } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const getCarriers = (t) => [
  { name: 'amazon', logo: '/images/package-room/amazon.svg', label: 'Amazon' },
  { name: 'ups', logo: '/images/package-room/ups.svg', label: 'UPS' },
  { name: 'fedex', logo: '/images/package-room/fedex.svg', label: 'FedEx' },
  { name: 'dhl', logo: '/images/package-room/dhl.svg', label: 'DHL' },
  { name: 'usps', logo: '/images/package-room/usps.svg', label: 'USPS' },
  { name: 'ontrac', logo: '/images/package-room/ontrac.svg', label: 'Ontrac' },
  { name: 'doordash', logo: '/images/package-room/doordash.svg', label: 'Doordash' },
  { name: 'uber-eats', logo: '/images/package-room/ubereats.svg', label: 'Uber Eats' },
  { name: 'postmates', logo: '/images/package-room/postmates.svg', label: 'Postmates' },
  { name: 'instacart', logo: '/images/package-room/instacart.svg', label: 'Instacart' },
  { name: 'other', logo: null, label: t('package-room:carrierSelection.other') },
]

const CarrierSelection = ({ onSelect, onBack }) => {
  const { t } = useTranslation(['package-room', 'common'])
  const handleCarrierSelect = (carrier) => {
    onSelect(carrier)
  }

  return (
    <div className="package-room__content package-room__content--full">
      <button className="package-room__back" onClick={onBack}>
        <ArrowLeft size={24} />
        {t('common:actions.back')}
      </button>
      <h2 className="package-room__title">{t('package-room:carrierSelection.title')}</h2>
      <div className="package-room__carrier-grid package-room__carrier-grid--two-columns">
        {getCarriers(t).map((carrier) => (
          <button
            key={carrier.name}
            className={`package-room__carrier-option ${
              carrier.name === 'other' ? 'package-room__carrier-option--full-width' : ''
            }`}
            onClick={() => handleCarrierSelect(carrier.name)}
          >
            {carrier.logo ? (
              <img src={carrier.logo} alt={carrier.label} className="package-room__carrier-logo" />
            ) : (
              carrier.label
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

CarrierSelection.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default CarrierSelection
